import {
  TRACK_CLICK_PRODUCT,
  TRACK_PRODUCT_VIEWED,
  TRACK_VARIANT_CLICKED,
} from '~gatsby-theme-autonomy/redux/actions/types'

export const trackClickProduct = (slug) => {
  return {
    type: TRACK_CLICK_PRODUCT,
    slug,
  }
}

export const trackProductViewed = ({ product }) => {
  return {
    type: TRACK_PRODUCT_VIEWED,
    product,
  }
}

export const trackVariantClicked = ({ product, variant }) => {
  return {
    type: TRACK_VARIANT_CLICKED,
    product,
    variant,
  }
}
